module.exports = __webpack_public_path__ + "files/c98b1ff2edde11699def84526d96c7fe.png";